import React from 'react'

import { Icon, XIcon } from 'components/shared/Icon/Icon'

import styles from './ClearIndicator.module.scss'

export const ClearIndicator = props => (
  <button className={styles.indicator} type="button" {...props}>
    <Icon className={styles.icon} icon={XIcon} size={16} />
  </button>
)
